import whiteLogo from '../../src/joni-and-friends-logo-white.png';

export default function Header({ podcastTitle }) {
  return (
    <header>
      <a href='https://www.joniandfriends.org/radio'>
        <img className='logo' src={whiteLogo} alt='Joni and Friends Logo' />
      </a>
      <h1 className='program-title'>{podcastTitle}</h1>
    </header>
  );
}
